import { render, staticRenderFns } from "./StudioUpcomingEventModal.vue?vue&type=template&id=4a5f6c6d&scoped=true&"
import script from "./StudioUpcomingEventModal.vue?vue&type=script&lang=ts&"
export * from "./StudioUpcomingEventModal.vue?vue&type=script&lang=ts&"
import style0 from "./StudioUpcomingEventModal.vue?vue&type=style&index=0&id=4a5f6c6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f6c6d",
  null
  
)

export default component.exports